import { CustomerChangeRequestSelectSchema } from "@norskgassnett/db";
import { z } from "zod";
import { StatusOk } from "../_core.js";
import { UpdateCompanyCustomerRequestBody } from "../business_central.js";
export const StartUpdateCustomerFlowRequestBody = z
    .object({
    id: z.string(),
    email: UpdateCompanyCustomerRequestBody.shape.email.transform((val) => val ? val.toLocaleLowerCase() : undefined),
    phoneNumber: UpdateCompanyCustomerRequestBody.shape.formasjonPhoneNo,
})
    .meta({ ref: "StartUpdateCustomerFlowRequestBody" });
export const StartUpdateCustomerFlowResponseBody = StatusOk.meta({
    ref: "StartUpdateCustomerFlowResponseBody",
});
export const CompleteUpdateCustomerFlowRequestBody = z
    .object({
    id: CustomerChangeRequestSelectSchema.shape.bcId,
    code: CustomerChangeRequestSelectSchema.shape.code,
    property: CustomerChangeRequestSelectSchema.shape.property,
})
    .meta({ ref: "CompleteUpdateCustomerFlowRequestBody" });
export const CompleteUpdateCustomerFlowResponseBody = StatusOk.meta({
    ref: "CompleteUpdateCustomerFlowResponseBody",
});
export const RelocateCustomerRequestBody = z
    .object({
    meterReading: z.coerce.number().nonnegative(),
    relocationDate: z.string().regex(/^\d{2}\.\d{2}\.\d{4}$/),
    invoiceAddress: z.string().min(1),
    postalCode: z.string().length(4),
    place: z.string().min(1),
    newOwnerName: z.string().min(3),
    newOwnerBirthdate: z.string().regex(/^\d{2}\.\d{2}\.\d{4}$/),
    newOwnerTlf: z.string().regex(/^\+\d{1,15}$/),
    newOwnerEmail: z.string().email().toLowerCase(),
    newOwnerAddress: z.string().min(4).optional(),
    newOwnerPostalCode: z.string().length(4).optional(),
    newOwnerPlace: z.string().min(1).optional(),
})
    .meta({ ref: "RelocateCustomerRequestBody" });
export const RelocateCustomerResponseBody = StatusOk.meta({
    ref: "RelocateCustomerResponseBody",
});
